import Home from './components/Home.vue';
import Disclaimer from './components/Disclaimer.vue';
import Training from './components/Training.vue';
import Program from './components/Program.vue';
import {store} from './store/store.js'

export const routes = [
    {path: '/home', component: Home, name: 'Home'},
    {path: '/disclaimer', component: Disclaimer, name: 'Disclaimer'},
    {path: '/training', component: Training, name: 'Training', beforeEnter: (to, from, next) => {
            if(store.getters.accessGranted || store.getters.debug) {
                next();
            } else {
                next('/');
            }
    }},
    {path: '/program', component: Program, name: 'Program', beforeEnter: (to, from, next) => {
            if (store.getters.accessGranted || store.getters.debug) {
                next();
            } else {
                next('/');
            }
    }},
    {path: '/*', component: Home, name: 'Base'},
];


// WEBPACK FOOTER //
// ./src/routes.js